import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const chunkIntoN = (arr: any[], n: number) => {
  const size = Math.ceil(arr.length / n);
  return Array.from({ length: n }, (_v, i) =>
    arr.slice(i * size, i * size + size),
  );
};

export function getBaseUrl() {
  const vc = process.env.VERCEL_URL ?? process.env.NEXT_PUBLIC_VERCEL_URL;
  if (vc) return `https://${vc}`;
  return 'http://localhost:3000';
}
